import styled from 'styled-components'

interface StyleProps {
    total: number
    fatal: number
    warn: number
    error: number
    info: number
    sizeField?: number
    first?: boolean
    dayOne?: boolean
}

export const AlarmsDashboardContainer = styled.div`
    background-color: var(--gray-300);
    padding: 16px 16px;
    display: flex;
    flex-direction: column;
    /* flex-wrap: wrap; */
    width: 100%;
    height: 100%;
    align-items: center;
    gap: 16px;
    overflow-x: auto;
    overflow-y: hidden;

    .close-button {
        position: absolute;
        z-index: 3;
        top: 10px;
        left: 10px;
        cursor: pointer;
        background-color: var(--gray-300);
    }

    .row-dashboard {
        display: flex;
        flex: 1;
        justify-content: space-around;
        align-items: flex-start;
        padding: 16px;
        height: 145px;
        gap: 16px;
        min-width: 1200px;
        max-width: 1200px;
        &.bottom {
            min-height: calc(100% - 160px);
            gap: 0px;
        }
    }

    .count-cards {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        flex: 1;
        align-items: center;
    }
`

export const AlarmGraph = styled.div`
    background: var(--gray-0);
    display: flex;
    flex-direction: row;
    max-width: 608px;
    min-width: 608px;
    height: 145px;
    flex-wrap: wrap;
    flex: 1;
    border-radius: 4px;
    padding: 9px 54px 0px 16px;

    .graphContainer {
        width: 100%;
        display: flex;
        flex-direction: column;

        .graphFields {
            width: 538px;
            height: 54px;
            display: flex;
            flex-direction: row;
            align-items: flex-end;
        }

        .graphTimeline {
            border-top: 1px solid #606a80;
            width: 538px;
            display: flex;
            flex-direction: row;

            .day {
                margin-left: 4px;
                margin-right: 4px;
                width: 9px;
                height: 24px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .mark {
                    background: #bac0cb;
                    width: 1px;
                    height: 8px;
                }
            }

            .day1 {
                margin-left: 10px;
                margin-right: 10px;
                font-weight: bold;
            }
        }
    }

    .graphicHeader {
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        align-items: flex-end;
        height: 40px;

        .graphTitle {
            i {
                margin-right: 4px;
                font-size: 14px;
                font-weight: 900;
            }

            .title-alert {
                font-size: 13px;
                font-weight: 600;
            }

            .title-days {
                color: var(--gray-700);
            }
        }

        .graphSubtitle {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: flex-end;

            .color {
                width: 8px;
                height: 8px;
                margin-bottom: 5px;
                margin-left: 16px;
            }

            .blue {
                background-color: #00bfff;
            }

            .orange {
                background-color: #ff9326;
            }

            .red {
                background-color: #ff4000;
            }

            .scarlet {
                background-color: #ae1f1f;
            }

            span {
                margin-left: 4px;
            }
        }
    }
`

export const AlarmGraphField = styled.div<StyleProps>`
    margin-left: ${props => (props.dayOne ? '10px' : props.first ? '4px' : '4px')};
    margin-right: ${props => (props.dayOne ? '10px' : '4px')};
    width: 9px;
    height: ${props => `${props.sizeField}%`};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* background: #ff4000; */
    .graphInfo {
        background-color: #00bfff;
        height: ${props => `${(100 / props.total) * props.info}%`};
        width: 9px;
    }

    .graphWarn {
        background-color: #ff9326;
        height: ${props => `${(100 / props.total) * props.warn}%`};
        width: 9px;
    }

    .graphError {
        background-color: #ff4000;
        height: ${props => `${(100 / props.total) * props.error}%`};
        width: 9px;
    }

    .graphFatal {
        background-color: #ae1f1f;
        height: ${props => `${(100 / props.total) * props.fatal}%`};
        width: 9px;
    }
`

export const GraphicPopover = styled.div`
    display: flex;
    flex-direction: column;

    .field {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .color {
        width: 8px;
        height: 8px;
        margin-right: 4px;
    }

    .blue {
        background-color: #00bfff;
    }

    .orange {
        background-color: #ff9326;
    }

    .red {
        background-color: #ff4000;
    }

    .scarlet {
        background-color: #ae1f1f;
    }
`
